export default "__VITE_ASSET__DJR6SqaK__"